export default class OfferRequestService {
  constructor($http) {
    this.$http = $http;
  }

  get(filter) {
    return this.$http.post(
      '/admin/marketplace/offer_requests/get_offer_requests',
      {filter: filter, authenticity_token: window.token}
    );
  }

  get_status_options() {
    return [
      {id: 1, title: 'Active'},
      {id: 0, title: 'Cancelled'}
    ];
  }

  create(offer_request) {
    return this.$http.post(
      '/admin/marketplace/offer_requests/create_offer_request',
      {offer_request: offer_request, authenticity_token: window.token}
    );
  }

  delete(offer_request_id) {
    return this.$http.post(
      '/admin/marketplace/offer_requests/delete',
      {offer_request_id: offer_request_id, authenticity_token: window.token}
    );
  }

  get_offer_request_items(offer_request_id) {
    return this.$http.get('/admin/marketplace/offer_requests/get_offer_request_items/' + offer_request_id);
  }

  get_details_data() {
    return this.$http.get('/admin/marketplace/offer_requests/get_details_data');
  }

  update(offer_request) {
    return this.$http.post(
      '/admin/marketplace/offer_requests/update',
      {offer_request: offer_request, authenticity_token: window.token}
    );
  }

  create_order_confirmation(offer_request_id, items) {
    return this.$http.post(
      '/admin/marketplace/offer_requests/create_order_confirmation',
      {offer_request_id: offer_request_id, items: items, authenticity_token: window.token}
    );
  }
  
  get_next_sc_id(offer_request_id, series) {
    return this.$http.post(
      '/admin/marketplace/offer_requests/get_next_sc_id',
      {offer_request_id: offer_request_id, series: series, authenticity_token: window.token}
    ); 
  }

  update_order_confirmation(order_confirmation_id, items) {
    return this.$http.post(
      '/admin/marketplace/offer_requests/update_order_confirmation',
      {order_confirmation_id: order_confirmation_id, items: items, authenticity_token: window.token}
    );
  }

  remove_order_confirmation_items(order_confirmation_id, items) {
    return this.$http.post(
      '/admin/marketplace/offer_requests/remove_order_confirmation_items',
      {order_confirmation_id: order_confirmation_id, items: items, authenticity_token: window.token}
    );
  }

  create_order_confirmation_docs(order_confirmation_id,sc_id=false) {
    return this.$http.post(
      '/admin/marketplace/offer_requests/create_order_confirmation_docs',
      {order_confirmation_id: order_confirmation_id, sc_id: sc_id, authenticity_token: window.token}
    );
  }

  create_order(order_confirmation_id) {
    return this.$http.post(
      '/admin/marketplace/offer_requests/create_order',
      {order_confirmation_id: order_confirmation_id, authenticity_token: window.token}
    );
  }

  connect_order(order_confirmation_id, order_id, copy_items) {
    return this.$http.post(
      '/admin/marketplace/offer_requests/connect_order',
      {order_confirmation_id: order_confirmation_id, order_id: order_id, copy_items: copy_items, authenticity_token: window.token}
    );
  }

  send_order_confirmation_notification(order_confirmation_id, doc_details, doc_specs, custom_text, contacts, sender_name_en, sender_name_el, test_send, test_send_email) {
    return this.$http.post(
      '/admin/marketplace/offer_requests/send_order_confirmation_notification',
      {order_confirmation_id: order_confirmation_id, doc_details: doc_details, doc_specs: doc_specs, custom_text: custom_text, contacts: contacts, sender_name_en: sender_name_en, sender_name_el: sender_name_el, test_send: test_send, test_send_email: test_send_email, authenticity_token: window.token}
    );
  }

  update_order_confirmation_field(order_confirmation_id, field, field_value) {
    return this.$http.post(
      '/admin/marketplace/offer_requests/update_order_confirmation_field',
      {order_confirmation_id: order_confirmation_id, field: field, field_value: field_value, authenticity_token: window.token}
    );
  }

  delete_order_confirmation(order_confirmation_id) {
    return this.$http.post(
      '/admin/marketplace/offer_requests/delete_order_confirmation',
      {order_confirmation_id: order_confirmation_id, authenticity_token: window.token}
    );
  }

  find_offer_request_items(filter) {
    return this.$http.post(
      '/admin/marketplace/offer_requests/find_offer_request_items',
      {filter: filter, authenticity_token: window.token}
    );
  }

  update_buyer_preferences(offer_request_id) {
    return this.$http.post(
      '/admin/marketplace/offer_requests/update_buyer_preferences',
      {offer_request_id: offer_request_id, authenticity_token: window.token}
    );
  }

  create_from_offer_items(offer_id, buyer_id, items) {
    return this.$http.post(
      '/admin/marketplace/offer_requests/create_from_offer_items',
      {offer_id: offer_id, buyer_id: buyer_id, items: items, authenticity_token: window.token}
    );
  }

  add_offer_items(offer_request_id, items) {
    return this.$http.post(
      '/admin/marketplace/offer_requests/add_offer_items',
      {offer_request_id: offer_request_id, items: items, authenticity_token: window.token}
    );
  }
}

OfferRequestService.$inject = ['$http'];



// WEBPACK FOOTER //
// ./front/js/admin/services/offer-request.service.js